module.exports = __webpack_public_path__ + "static/media/lehuilin.27c2099b.jpg";